import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    root: {
        display: 'flex',
        marginTop: 15,
        alignItems: 'center',
        justifyContent: 'center',
    }
}))